import { useTranslation } from 'react-i18next';

const tone = { info: 'info', warning: 'warn', critical: 'crit' };

export default function SeverityBadge({ severity }) {
  const { t } = useTranslation();
  return <span className={`badge ${tone[severity] || 'info'}`}>{t(`severity.${severity}`, severity)}</span>;
}
